import apiClient from '../client.js'

export const usersAPI = {
  // Profile management
  async getProfile() {
    const response = await apiClient.get('/users/profile')
    return response.data
  },

  async updateProfile(profileData) {
    const response = await apiClient.put('/users/profile', profileData)
    return response.data
  },

  async changePassword(passwordData) {
    const response = await apiClient.post('/users/change-password', passwordData)
    return response.data
  },

  // Profile picture (brand feature "avatars"): a stock one by name, or an upload
  async chooseAvatar(avatar) {
    const response = await apiClient.put('/users/avatar', { avatar })
    return response.data
  },

  async uploadAvatar(file) {
    const formData = new FormData()
    formData.append('image', file)
    const response = await apiClient.post('/users/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  // Address management
  async getAddresses() {
    const response = await apiClient.get('/users/addresses')
    return response.data
  },

  async getAddress(addressId) {
    const response = await apiClient.get(`/users/addresses/${addressId}`)
    return response.data
  },

  async createAddress(addressData) {
    const response = await apiClient.post('/users/addresses', addressData)
    return response.data
  },

  async updateAddress(addressId, addressData) {
    const response = await apiClient.put(`/users/addresses/${addressId}`, addressData)
    return response.data
  },

  async deleteAddress(addressId) {
    const response = await apiClient.delete(`/users/addresses/${addressId}`)
    return response.data
  },

  async setDefaultAddress(addressId) {
    const response = await apiClient.put(`/users/addresses/${addressId}/default`)
    return response.data
  },

  // Preferences management
  async getPreferences() {
    const response = await apiClient.get('/users/preferences')
    return response.data
  },

  async updatePreferences(preferencesData) {
    const response = await apiClient.put('/users/preferences', preferencesData)
    return response.data
  },

  // Admin user management
  async getAllUsers(params = {}) {
    const response = await apiClient.get('/admin/users', { params })
    return response.data
  },

  async getUsers(params = {}) {
    const response = await apiClient.get('/admin/users', { params })
    return response.data
  },

  async getUserStats() {
    const response = await apiClient.get('/admin/users/stats')
    return response.data
  },

  async getUserDailyStats(params = {}) {
    const response = await apiClient.get('/admin/users/daily-stats', { params })
    return response.data
  },

  async getAdminUser(userId) {
    const response = await apiClient.get(`/admin/users/${userId}`)
    return response.data
  },

  async createUser(userData) {
    const response = await apiClient.post('/admin/users', userData)
    return response.data
  },

  async updateUser(userId, userData) {
    const response = await apiClient.put(`/admin/users/${userId}`, userData)
    return response.data
  },

  async toggleUserActive(userId) {
    const response = await apiClient.patch(`/admin/users/${userId}/toggle-active`)
    return response.data
  },

  async deleteUser(userId) {
    const response = await apiClient.delete(`/admin/users/${userId}`)
    return response.data
  },

  async toggleVerifiedCustomer(userId) {
    const response = await apiClient.patch(`/admin/users/${userId}/verify-customer`)
    return response.data
  },

  async updateCompanyAccountType(userId, data) {
    const response = await apiClient.put(`/admin/users/${userId}/company-account-type`, data)
    return response.data
  }
}
